import React, { useEffect, useState } from 'react';
import { useLoginContext } from '../../../App';
import { useContentContext } from '../../layout/Layout';
import useLogbook from './useLogbook';
import LogbookModal from './LogbookModal';
import { newAreaLogbookDTO } from './logbookDTOs'; // Create a file for DTOs
import { fetchAreaLogbook } from '../../../services/b2b-logbook-apiServices';
import useAccessControl from '../../b2b-users/hooks/useAccessControl';
import LogbookWhiteList from '../components/whitelist/LogbookWhiteList';
import { AdminPanelSettings } from '@mui/icons-material';
import { AreaAchievementsAndAccessStageDetails } from '../../b2b-plans/pages/PlanDetailsPage';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const AreaLogbookModal = ({ logbookRelatedEntity = null, open, onClose }) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-logbook');

    const [showHeader, setShowHeader] = useState(true);

    const {
        currentOpen,
        setCurrentOpen,
        currentLogbook,
        setCurrentLogbook,
        currentFolder,
        newLogbookConfirmationRequest,
        setNewLogbookConfirmationRequest,
        logbookDeleteConfirmationRequest,
        setLogbookDeleteConfirmationRequest,
        handleCreateNewLogbook,
        handleUpdatedLogbook,
        handleFolderChange,
        handleDeleteLogbook,
        handleClose,
    } = useLogbook('AREA', loginData, setNotification, t, onClose, logbookRelatedEntity, newAreaLogbookDTO, fetchAreaLogbook);

    useEffect(() => {
        if (open && (currentOpen !== open)) {
            setCurrentOpen(true);
        }
    }, [currentOpen, open, setCurrentOpen]);

    const { checkAccess: showWhiteList } = useAccessControl([
        {
            productsRequired: ['B2B_LOGBOOK'],
            rolesRequired: ['ADMIN', 'EDITOR']
        },
    ]);

    const tabsConfig = [
        {
            label: t('Area'),
            icon: null,
            content: (
                <>
                    <AreaAchievementsAndAccessStageDetails selectedArea={logbookRelatedEntity} />
                </>
            ),
            showTab: true,
        },
        {
            label: t('Security whitelist'),
            icon:
                <AdminPanelSettings
                    style={{ color: currentLogbook?.logBookProtected ? '#011d89' : 'grey' }}
                />,
            content: (
                <LogbookWhiteList logbook={currentLogbook} setLogbook={setCurrentLogbook} />
            ),
            showTab: showWhiteList(),
        },
    ];

    return (
        <LogbookModal
            currentOpen={currentOpen}
            currentLogbook={currentLogbook}
            currentFolder={currentFolder}
            newLogbookConfirmationRequest={newLogbookConfirmationRequest}
            logbookDeleteConfirmationRequest={logbookDeleteConfirmationRequest}
            setNewLogbookConfirmationRequest={setNewLogbookConfirmationRequest}
            setLogbookDeleteConfirmationRequest={setLogbookDeleteConfirmationRequest}
            handleCreateNewLogbook={handleCreateNewLogbook}
            handleUpdatedLogbook={handleUpdatedLogbook}
            handleFolderChange={handleFolderChange}
            handleDeleteLogbook={handleDeleteLogbook}
            handleClose={handleClose}
            showHeader={showHeader}
            setShowHeader={setShowHeader}
            tabsConfig={tabsConfig}
            t={t}
            headerTitle={t('Logbook for plan:')}
            headerMessage={logbookRelatedEntity?.planName}
        />
    );
};

export default AreaLogbookModal;